import { createFileRoute, redirect } from "@tanstack/react-router";

import { SettingsSearchSchema } from "@/pages/settings/route";
import { searchValidator } from "@/utils/search-validator";

/** Keeps older Slack OAuth redirect URLs working until env is updated. */
export const Route = createFileRoute("/settings/integrations/slack-redirect")({
    validateSearch: searchValidator(SettingsSearchSchema),
    beforeLoad: ({ search }) => {
        throw redirect({
            to: "/settings",
            search,
        });
    },
});
